/*
  pdp-urgency-chips.js
  WHAT: Live countdowns for PDP urgency chips.
        - Dispatch: counts down to the day's cutoff (HH:MM). Switches to "tomorrow" copy
          once today's cutoff has passed.
        - Sale-ends: counts down to the absolute ISO time on the product metafield.
          Shown only when the remaining window ≤ data-sale-window-hours.
  WHY:  Memory `pdp-urgency-priority` — dispatch always-on, sale-ends conditional.
  WHEN: Added 2026-05-28 with PDP Step 2.
*/

(function () {
  'use strict';

  var TICK_MS = 30000; // Update twice a minute — chip granularity is "Xh Ym" so 30s is enough.

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatDuration(ms) {
    if (ms <= 0) return '0m';
    var totalMin = Math.floor(ms / 60000);
    var days = Math.floor(totalMin / 1440);
    var hours = Math.floor((totalMin % 1440) / 60);
    var mins = totalMin % 60;
    if (days > 0) return days + 'd ' + hours + 'h';
    if (hours > 0) return hours + 'h ' + pad(mins) + 'm';
    return mins + 'm';
  }

  // ─── Dispatch chip ───────────────────────────────────────────────────────
  // Always-on. Counts down to today's cutoff (HH:MM local). After the cutoff,
  // switches to tomorrow's cutoff and the sub-text flips to "next-day dispatch".
  function updateDispatch(chip) {
    var cutoff = chip.getAttribute('data-cutoff') || '16:00';
    var parts = cutoff.split(':');
    var cutH = parseInt(parts[0], 10) || 16;
    var cutM = parseInt(parts[1], 10) || 0;

    var now = new Date();
    var cut = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutH, cutM, 0, 0);

    var sub = chip.querySelector('.ba-pdp-urgency__sub');
    var countdown = chip.querySelector('[data-pdp-dispatch-countdown]');

    var ms = cut - now;
    if (ms <= 0) {
      // Past today's cutoff — roll to tomorrow.
      cut.setDate(cut.getDate() + 1);
      ms = cut - now;
      if (sub) sub.textContent = 'next-day dispatch';
    }

    if (countdown) countdown.textContent = formatDuration(ms);
  }

  // ─── Sale-ends chip ──────────────────────────────────────────────────────
  // Conditional. Reveal only when remaining time ≤ data-sale-window-hours.
  function updateSale(chip) {
    var ends = chip.getAttribute('data-ends');
    var windowHours = parseInt(chip.getAttribute('data-sale-window-hours'), 10) || 48;
    if (!ends) return;

    var endTime = new Date(ends);
    if (isNaN(endTime.getTime())) return;

    var now = new Date();
    var ms = endTime - now;

    if (ms <= 0) {
      // Sale has expired — hide.
      chip.hidden = true;
      return;
    }

    var windowMs = windowHours * 3600000;
    if (ms > windowMs) {
      // Outside the visibility window — keep hidden.
      chip.hidden = true;
      return;
    }

    // Inside the window — reveal + update.
    chip.hidden = false;
    var countdown = chip.querySelector('[data-pdp-sale-countdown]');
    if (countdown) countdown.textContent = formatDuration(ms);
  }

  function tick() {
    document.querySelectorAll('[data-pdp-dispatch]').forEach(updateDispatch);
    document.querySelectorAll('[data-pdp-sale]').forEach(updateSale);
  }

  function init() {
    tick();
    setInterval(tick, TICK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
